import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OccEndpointsService } from '@spartacus/core';

import { CustomAddressForm, ContactInfoForm, NewsLetterForm } from '../models';
import { BaseStoreService } from '../services/base-store.service';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {
  private readonly baseStoreService = inject(BaseStoreService);
  private readonly http = inject(HttpClient);
  private readonly occEndpointsService = inject(OccEndpointsService);

  private get countryIsoCode() {
    return this.baseStoreService.baseStore.market;
  }

  getAddressFormByCountry(): Observable<CustomAddressForm> {
    const url = this.occEndpointsService.buildUrl('addressForm', {
      urlParams: { countyIsoCode: this.countryIsoCode }
    });
    return this.http.get<CustomAddressForm>(url);
  }

  getContactInfoFormByCountry(): Observable<ContactInfoForm> {
    const url = this.occEndpointsService.buildUrl('contactInfoForm', {
      urlParams: { countyIsoCode: this.countryIsoCode }
    });
    return this.http.get<ContactInfoForm>(url);
  }

  getNewsLetterBySite(): Observable<NewsLetterForm> {
    const url = this.occEndpointsService.buildUrl('newsLetterForm', {
      urlParams: { countyIsoCode: this.countryIsoCode }
    });
    return this.http.get<NewsLetterForm>(url);
  }
}
